module.exports = __webpack_public_path__ + "img/icon6.bbda68b1.png";